import { createAction } from 'typesafe-actions'
import { type DefaultQueryType } from './global.types'
import { type DefaultAnalyticsRequest } from '@/connect-types/analytics/request.type'

/* Test global action: open/close info banner */

/**
 * Info banner
 */

export const setQuery = createAction(
  'GLOBAL_SET_QUERY',
  (resolve: any) => (query: Partial<DefaultQueryType>) => resolve({ query })
)

export const setListStyle = createAction(
  'GLOBAL_LIST_STYLE',
  (resolve: any) => (style: 'list' | 'grid') => resolve(style)
)

export const setSelectedReviewPageId = createAction(
  'GLOBAL_SET_SELECTED_REVIEW_PAGE_ID',
  (resolve: any) => (id: string) => resolve({ id })
)

export const setOrgId = createAction(
  'GLOBAL_SET_ORG_ID',
  (resolve: any) => (orgId: string) => resolve({ orgId })
)

export const setDemoMode = createAction(
  'GLOBAL_SET_DEMO_MODE',
  (resolve: any) => (isDemoMode: boolean) => resolve({ isDemoMode })
)

/**
 * Analytics payload
 */

export const setAnalyticsPayload = createAction(
  'GLOBAL_SET_ANALYTICS_PAYLOAD',
  (resolve: any) => (request: DefaultAnalyticsRequest) => resolve({ request })
)

export const setInitialSearch = createAction(
  'SET_INITIAL_SEARCH',
  (resolve: any) => (term: string) => resolve({ term })
)
